import { render } from "./PluginsSummary.vue?vue&type=template&id=6db907ce&scoped=true"
import script from "./PluginsSummary.vue?vue&type=script&lang=js"
export * from "./PluginsSummary.vue?vue&type=script&lang=js"

import "./PluginsSummary.vue?vue&type=style&index=0&id=6db907ce&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6db907ce"]])

export default __exports__